import "./Collection.css";
import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import CollectionPostGridCard from "./Components/CollectionPostGridCard";
import CollectionAnalytics from "./Components/CollectionAnalytics";
import fileDownload from "js-file-download";
import axios from "axios";
import TopHeader from "../TopHeader";
import Footer from "../Footer";

const Collection = () => {
  let location = useLocation();

  const [error, setError] = useState();
  const [items, setItems] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const urlParams = new URLSearchParams(location.search);
  const coll_id = urlParams.get("coll_id");
  const coll_name = urlParams.get("coll_name");
  const [brandName, setBrandName] = useState();
  const topHeaderRef = useRef(null);

  // Publish TopHeader's actual rendered height as a CSS var so
  // .sticky-analytics can pin precisely below it at every breakpoint
  // without guessing min-heights or padding totals.
  useEffect(() => {
    const el = topHeaderRef.current;
    if (!el) return;
    const apply = () => {
      const h = el.offsetHeight;
      document.documentElement.style.setProperty(
        "--top-header-height",
        `${h}px`,
      );
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from_date = params.get("from_date");
    const to_date = params.get("to_date");
    getCollectionMedia(from_date, to_date);
    getCollectionAnalytics(from_date, to_date);
  }, [location.search]);

  const buildDateQuery = (from_date, to_date) => {
    const qs = new URLSearchParams();
    if (from_date) qs.set("from_date", from_date);
    if (to_date) qs.set("to_date", to_date);
    const s = qs.toString();
    return s ? `?${s}` : "";
  };

  //------------ NEW -------------------

  const downloadMediaAPI = (media_id, content) => {
    return Promise.all(
      content.media.map((obj, index) => {
        if (obj.viewable_media_type === "VIDEO") {
          return downloadVideoPostHandler(
            index,
            `${content.creator?.username.replace(/[^a-zA-Z 0-9]+/g, "")}-UGC.mp4`,
            content,
          );
        } else {
          return downloadImagePostHandler(
            index,
            `${content.creator?.username.replace(/[^a-zA-Z 0-9]+/g, "")}-UGC.png`,
            content,
          );
        }
      }),
    );
  };

  const downloadImagePostHandler = (media_index, filename, content) => {
    //----- File Downloading Code ----------
    return axios
      .get(content.media[media_index].download_url + `?filename=${filename}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  const downloadVideoPostHandler = (media_index, filename, content) => {
    return axios
      .get(content.media[media_index].download_url + `?filename=${filename}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  //------------ NEW -------------------

  function getCollectionMedia(from_date, to_date) {
    try {
      fetch(
        process.env.REACT_APP_API_URI +
          `v1/public/collections/${coll_id}/media${buildDateQuery(from_date, to_date)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => {
          if (response.status === 200) {
            //setRegister(!isRegister);
            response.json().then((data) => {
              setBrandName(data.brand_name);
              const newArr = data.media.map((v) => ({
                ...v,
                show_usage_rights: true,
                is_video_playing: false,
                is_marked_as_customer: false,
              }));
              setItems([]);
              setItems(newArr);
            });
          } else {
            setError({
              title: "Error",
              message: "Something went wrong",
            });
          }
        })
        .catch((err) => {
          setError({
            title: "Error",
            message: "Something went wrong",
          });
        });
    } catch (err) {
      setError({
        title: "Error",
        message: "Something went wrong",
      });
    }
  }

  function getCollectionAnalytics(from_date, to_date) {
    try {
      fetch(
        process.env.REACT_APP_API_URI +
          `v1/public/collections/${coll_id}/insights${buildDateQuery(from_date, to_date)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => {
          if (response.status === 200) {
            response.json().then((data) => {
              setAnalytics(data);
            });
          }
        })
        .catch(() => {});
    } catch (err) {}
  }

  return (
    <div className="center-vertically">
      <div className="sticky-top-header" ref={topHeaderRef}>
        <TopHeader brandName={brandName} comingFrom="Collection" />
      </div>
      <header className="collection-header-block">
        <div className="collection-eyebrow">SHARED COLLECTION</div>
        <h1 className="collection-title">{brandName || " "}</h1>
        {coll_name && (
          <div className="collection-subtitle">
            <span className="collection-subtitle-dash" aria-hidden="true">
              —
            </span>
            <span>{coll_name}</span>
          </div>
        )}
        <p className="collection-description">
          A curated snapshot of creator content and the performance behind it
          — filter by date to focus a window.
        </p>
      </header>
      <div className="sticky-analytics">
        <CollectionAnalytics
          items={items}
          stats={{
            posts: analytics?.posts,
            creators: analytics?.users,
            impressionsRaw: analytics?.impressions,
            engagementRaw: analytics?.engagement,
            emvRaw: analytics?.emv,
          }}
        />
      </div>
      <div className="collection-grid-wrapper">
        {items.length > 0 ? (
          <CollectionPostGridCard
            contentData={items}
            downloadMediaAPI={downloadMediaAPI}
          />
        ) : (
          <span></span>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Collection;
